import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { MailWarning, LogOut } from "lucide-react";

/** Schermata di blocco: mostrata dopo 48h se l'utente non ha verificato l'email.
 * Contiene SOLO il bottone "Reinvia email di verifica" + logout.
 */
export default function VerifyEmailBlockScreen() {
  const { user, logout } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success("Nuova email inviata. Controlla la casella.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossibile reinviare");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4" data-testid="verify-block-screen">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <Card className="p-8 rounded-2xl border text-center">
          <div className="w-14 h-14 rounded-full bg-secondary/10 flex items-center justify-center mb-4 mx-auto">
            <MailWarning className="w-7 h-7 text-secondary" />
          </div>
          <h1 className="font-heading font-bold text-2xl mb-2">Verifica la tua email per continuare</h1>
          <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
            Sono passate più di 48 ore dalla registrazione e il link di verifica è scaduto.
            Richiedi un nuovo link per accedere all'app.
          </p>
          <div className="p-3 bg-muted/40 rounded-xl text-sm mb-6">
            <span className="text-muted-foreground">Email registrata:</span> <strong>{user?.email}</strong>
          </div>
          <div className="space-y-2">
            <Button
              className="w-full h-11 rounded-full"
              onClick={resend}
              disabled={sending}
              data-testid="verify-block-resend"
            >
              {sending ? "Invio in corso…" : sent ? "Nuova email inviata ✓ (reinvia)" : "Reinvia email di verifica"}
            </Button>
            <Button
              variant="ghost"
              className="w-full h-11 rounded-full"
              onClick={logout}
              data-testid="verify-block-logout"
            >
              <LogOut className="w-4 h-4 mr-2" /> Esci
            </Button>
          </div>
          <p className="text-xs text-muted-foreground mt-6">
            Problemi? <a href="mailto:info@tuotax.it" className="text-primary hover:underline">Scrivici a info@tuotax.it</a>
          </p>
        </Card>
      </div>
    </div>
  );
}
